/**
 * WearJAGS Premium Page Transition
 * Smoothly animates card clicks before navigating.
 */
(function() {
  const style = document.createElement('style');
  style.textContent = `
    .premium-page-transition-zoom {
      transform: scale(1.08) !important;
      transition: transform 500ms cubic-bezier(0.25, 1, 0.5, 1), filter 500ms ease !important;
    }
    .premium-page-transition-overlay {
      position: absolute !important;
      inset: 0 !important;
      background-color: rgba(0,0,0,0.15) !important;
      opacity: 0;
      transition: opacity 500ms ease !important;
      z-index: 10 !important;
      pointer-events: none !important;
    }
    .premium-page-transition-overlay.is-active {
      opacity: 1 !important;
    }
    .premium-page-transition-main {
      opacity: 0.3 !important;
      filter: blur(4px) !important;
      transition: opacity 500ms ease, filter 500ms ease !important;
    }
  `;
  document.head.appendChild(style);

  document.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (!link) return;
    
    // Ignore modifier clicks (open in new tab etc)
    if (e.ctrlKey || e.shiftKey || e.metaKey || e.button === 1 || e.button === 2) return;
    if (link.target === '_blank') return;
    
    const hrefAttr = link.getAttribute('href');
    if (!hrefAttr || 
        hrefAttr.startsWith('#') || 
        hrefAttr.startsWith('javascript') || 
        hrefAttr.startsWith('mailto:') || 
        hrefAttr.startsWith('tel:')) {
      return;
    }

    // Identify if the click is inside a recognized premium card component
    const card = link.closest('.collection-card, .custom-premium-product-card, .card-wrapper, .card');
    if (!card) return;
    
    // Avoid triggering on add-to-cart or quick-add buttons inside the card
    if (e.target.closest('button, .quick-add, .product-card__action-btn')) return; 

    // Prevent instant navigation
    e.preventDefault();

    // 1. Zoom image
    const img = card.querySelector('img, video');
    if (img) {
      img.classList.add('premium-page-transition-zoom');
    }

    // 2. Overlay soft fade
    const imgWrapper = card.querySelector('.collection-card__image-wrapper, .premium-product-card__media, .card__inner') || card;
    const overlay = document.createElement('div');
    overlay.className = 'premium-page-transition-overlay';
    imgWrapper.appendChild(overlay);

    // Force browser to recalculate styles so transition applies
    overlay.offsetHeight;
    overlay.classList.add('is-active');

    // 3. Page blur and fade out
    const mainContent = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    if (mainContent) {
      mainContent.classList.add('premium-page-transition-main');
    }

    // Execute navigation after animation
    setTimeout(() => {
      window.location.href = link.href;
    }, 450);
  });

  // Handle browser back button (bfcache) - reset state unconditionally on pageshow
  window.addEventListener('pageshow', function() {
    const mainContent = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    if (mainContent) {
      mainContent.classList.remove('premium-page-transition-main');
    }
    
    document.querySelectorAll('.premium-page-transition-zoom').forEach(el => {
      el.classList.remove('premium-page-transition-zoom');
    });
    
    document.querySelectorAll('.premium-page-transition-overlay').forEach(el => el.remove());
  });
})();
